import React from 'react'
import './StatusShowInfo.css';

const StatusShowInfo = ({infoAboutDriver}) => {
  const server = process.env.REACT_APP_SERVER_ADRES;

  const imgOfAvatar = server + "avatarOfDrivers/"+ infoAboutDriver.id+".jpeg"
  
    return (
      <div className='StatusInCyrcle'>
        <div className="card">
            <img src={imgOfAvatar} alt="" />
            <p>{infoAboutDriver.type}</p>
            <p>SPZ: {infoAboutDriver.spz}</p>
        </div>
      </div>
    )
}

export default StatusShowInfo
